module.exports = __webpack_public_path__ + "img/card_0.3fbf44f1.png";